import { createAction } from 'redux-actions';

export const getSettingShoppingCartRequested = createAction('GET_SETTING_SHOPPING_CART_REQUEST');
export const getSettingShoppingCartReceived = createAction('GET_SETTING_SHOPPING_CART_RECEIVED');
export const getSettingShoppingCartReceiveFailure = createAction('GET_SETTING_SHOPPING_CART_RECEIVE_FAILURE');
export const getSettingShoppingCartClear = createAction('GET_SETTING_SHOPPING_CART_CLEAR');

export const updateSettingShoppingCartRequested = createAction('UPDATE_SETTING_SHOPPING_CART_REQUEST');
export const updateSettingShoppingCartReceived = createAction('UPDATE_SETTING_SHOPPING_CART_RECEIVED');
export const updateSettingShoppingCartReceiveFailure = createAction('UPDATE_SETTING_SHOPPING_CART_RECEIVE_FAILURE');
export const updateSettingShoppingCartClear = createAction('UPDATE_SETTING_SHOPPING_CART_CLEAR');
